import About from './abouts';
import Slider from "./slider"
import Vision from './vision';
import Mission from "./mission";
import Map from "./map"
import Clients from './clients';
import Products from "./products";
import { useGSAP } from "@gsap/react";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/all";
import { useRef, useState } from "react";
import CounterSection from './range';

gsap.registerPlugin(ScrollTrigger);

const MainPage = ({searchValue}) => {
  const containerRef = useRef();

  useGSAP(() => {
    const tl5 = gsap.timeline({
      scrollTrigger: {
        trigger: ".clients-gsap",
        start: "top 60%",
        end: "top 40%",
        scrub: 1,
      },
    });

    tl5.from(".clients-gsap", {
      y: -100,
      opacity: 0,
      duration: 1,
    }).from(".clients-heading-gsap", {
      y: -100,
      opacity: 0,
      duration: 1,
    });

  }, { scope: containerRef }); 

 
  return (
    <div ref={containerRef}>
    
      <Slider />
        <Vision />
      <About />
    
     
        <Mission />
      <Products />

      <section className='clients d-flex justify-content-center clients-gsap'>
        <div className='col-11 pt-4 pb-5'>
          <div className="position-relative heading-container mx-auto ">
            <h2 className="heading clients-heading-gsap">
              C<span className="heading-span">LIENTS</span>
            </h2>
            <div className="line"></div>
          </div>
          <Clients />
        </div>
      </section>
 <CounterSection/>
    
      
      <Map/>
    </div>
 
  );
};

export default MainPage;
